export enum OffersTableColumnsTitle {
  Term = 'Term',
  FixedRate = 'Fixed Rate',
  APR = 'APR',
  MonthlyPayments = 'Monthly Payments',
  Action = 'Action',
}
